'use client';

import { useEffect } from 'react';
import { logger } from '@/lib/logger';
import { ErrorDisplay } from '@/components/error-display';

export default function AuthenticatedError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    logger.error('Authenticated route error boundary caught:', error);
  }, [error]);

  // Check if it's an authentication error
  const isAuthError = error.message?.includes('authentication') || 
                      error.message?.includes('unauthorized') ||
                      error.message?.includes('login');

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <ErrorDisplay
        error={error}
        onRetry={isAuthError ? undefined : reset}
        showContactSupport={true}
        variant={isAuthError ? 'authentication' : 'default'}
      />
    </div>
  );
}